import { clientStore } from '../services/axiosInstance'

export async function getTopSearches() {
  try {
    const { data } = await clientStore.get(
      `/_v/api/decathlon-search/top_searches`,
      {
        params: {
          engine: 'vtex',
        },
      }
    )

    return data
  } catch (error) {
    console.error(error)

    return null
  }
}
